import { render, staticRenderFns } from "./QuestionsurveyDetail.vue?vue&type=template&id=f5494f3c&scoped=true"
import script from "./QuestionsurveyDetail.vue?vue&type=script&lang=js"
export * from "./QuestionsurveyDetail.vue?vue&type=script&lang=js"
import style0 from "./QuestionsurveyDetail.vue?vue&type=style&index=0&id=f5494f3c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5494f3c",
  null
  
)

export default component.exports